import { render, staticRenderFns } from "./businessFollower.vue?vue&type=template&id=0c28c874&scoped=true&"
import script from "./businessFollower.vue?vue&type=script&lang=js&"
export * from "./businessFollower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28c874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c28c874')) {
      api.createRecord('0c28c874', component.options)
    } else {
      api.reload('0c28c874', component.options)
    }
    module.hot.accept("./businessFollower.vue?vue&type=template&id=0c28c874&scoped=true&", function () {
      api.rerender('0c28c874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/team/businessFollower.vue"
export default component.exports